'use client'

import { Emoji } from '@/components/between-sessions/Emoji'

// Compact grid of the remaining pillars (community, practice support,
// tools, clinical dev). These are real value, but they're supporting
// cast — supervision and referrals are the leads, so these get one
// column each rather than a full-viewport section apiece.
const PILLARS: { emoji: string; title: string; body: string }[] = [
  {
    emoji: 'fluent-emoji-high-contrast:heart-hands',
    title: 'Community',
    body: 'Monthly live peer meetups + a community board where therapists post the hard cases, wins, and questions you can’t ask anywhere else.',
  },
  {
    emoji: 'fluent-emoji-high-contrast:briefcase',
    title: 'Practice support',
    body: 'Templates, workflows, partner discounts on EHRs/insurance/marketing, and a monthly marketing group led by a specialist.',
  },
  {
    emoji: 'fluent-emoji-high-contrast:toolbox',
    title: 'Tools built for therapists',
    body: 'CRPO hours auto-tracked, PD hours logged and exportable, self-assessments, therapist job board.',
  },
  {
    emoji: 'fluent-emoji-high-contrast:graduation-cap',
    title: 'Clinical development',
    body: 'Live + recorded peer knowledge networks, themed clinical education every month, and space to host your own when you have something to share.',
  },
]

export function LandingPillarsGrid() {
  return (
    <section className="px-6 py-24 sm:py-28 bg-white border-y border-[#ececec]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.22em] text-bs-secondary-700 font-display font-semibold mb-4">
            Everything else that comes with membership
          </p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-gray-900 mb-4">
            Not just{' '}
            <span className="italic text-bs-secondary-500">supervision</span>{' '}
            and{' '}
            <span className="italic text-bs-secondary-500">referrals</span>.
          </h2>
          <p className="text-[16px] text-gray-600 leading-relaxed">
            Every tier includes the pieces below. Take what helps, when it
            helps — no pressure to use it all.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map(p => (
            <div
              key={p.title}
              className="rounded-[1.4rem] border border-[#ececec] bg-[#faf9f6] p-6 hover:-translate-y-1 hover:shadow-[0_16px_32px_-16px_rgba(20,20,20,0.18)] hover:border-bs-secondary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-white border border-[#ececec] flex items-center justify-center text-bs-secondary-500 mb-4 shadow-[0_6px_16px_-8px_rgba(20,20,20,0.15)]">
                <Emoji name={p.emoji} size={26} />
              </div>
              <h3 className="font-display font-bold text-[19px] text-gray-900 mb-2 leading-tight">
                {p.title}
              </h3>
              <p className="text-[13.5px] text-gray-600 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
